import { ErrorBoundary, type ErrorBoundaryProps } from "@prismicio/editor-ui"
import { QueryErrorResetBoundary } from "@tanstack/react-query"

type EditorErrorBoundaryProps = Omit<ErrorBoundaryProps, "onReset">

export function EditorErrorBoundary(props: EditorErrorBoundaryProps) {
  const { children, ...rest } = props

  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary {...rest} onReset={reset}>
          {children}
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  )
}
